import { useEffect } from 'react';
import { useWizard } from '../../context/WizardContext';
import { Input } from '../UI/Input';
import { Button } from '../UI/Button';
import { ArrowRight, ArrowLeft } from 'lucide-react';

export function PurchaseStep() {
  const { state, updateFormData, nextStep, prevStep, setError, clearError } = useWizard();
  const { purchaseInfo } = state.formData;

  useEffect(() => {
    const hasTicket = state.formData.attachments?.ticket;
    const hasAnyData = purchaseInfo?.folio || purchaseInfo?.purchaseDate || purchaseInfo?.amount;
    
    if (!hasTicket && !hasAnyData) {
      setError('purchase', 'Debes adjuntar un ticket o proporcionar al menos un dato de compra.');
    } else {
      clearError('purchase');
    }
  }, [purchaseInfo, state.formData.attachments?.ticket, setError, clearError]);

  const handleChange = (field: keyof typeof purchaseInfo, value: string | number) => {
    updateFormData({
      purchaseInfo: {
        ...purchaseInfo,
        [field]: value,
      },
    });
  };

  return (
    <div className="max-w-2xl mx-auto animate-fade-in">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Identificación de compra
        </h2>
        <p className="text-gray-600">
          Proporciona los datos de tu compra. Si no los recuerdas, adjunta tu ticket en el paso final.
        </p>
      </div>

      <div className="space-y-6">
        <Input
          label="Folio/Ticket (opcional)"
          placeholder="Ej: TKT-123456"
          value={purchaseInfo?.folio || ''}
          onChange={(e) => handleChange('folio', e.target.value)}
          helper="Número de folio o ticket de tu compra"
        />

        <Input
          label="Fecha de compra (opcional)"
          type="date"
          value={purchaseInfo?.purchaseDate || ''}
          onChange={(e) => handleChange('purchaseDate', e.target.value)}
          helper="Fecha en que realizaste la compra"
        />

        <Input
          label="Monto (opcional)"
          type="number"
          placeholder="Ej: 1500.00"
          value={purchaseInfo?.amount || ''}
          onChange={(e) => handleChange('amount', parseFloat(e.target.value) || 0)}
          helper="Monto total de la compra"
          min="0"
          step="0.01"
        />

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            <strong>Nota:</strong> Si no recuerdas estos datos, adjunta tu ticket y continúa.
          </p>
        </div>
      </div>

      <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-200">
        <Button
          onClick={prevStep}
          variant="ghost"
          icon={ArrowLeft}
        >
          Atrás
        </Button>
        <Button
          onClick={nextStep}
          icon={ArrowRight}
          disabled={!!state.errors.purchase}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
}